import { useLocation } from 'react-router-dom';
import MenuTabsPresentational from '../presentational/MenuTabs';
import { userManagerQuery } from '../../../constants/userManagerConstants';

const MenuTabsContainer = ({ menuList }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const activeTag = queryParams.get(userManagerQuery.tags);
  const activeMenuIdx = menuList.findIndex((menu) => menu.tags === activeTag);
  const resolvedActiveIdx = activeMenuIdx >= 0 ? activeMenuIdx : 0;

  return (
    <MenuTabsPresentational
      menuList={menuList}
      resolvedActiveIdx={resolvedActiveIdx}
      pathname={location.pathname}
      queryParamKey={userManagerQuery.tags}
    />
  );
};

export default MenuTabsContainer;
